// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2yX6l","unreadBadge":"styles_unreadBadge__u_gMS","modalContent":"styles_modalContent__LTvWN","modal":"styles_modal__1N7PL"};